<template>
  <div>
    <vue-cropper
      v-if="show"
      ref="vueCropper"
      :Options="3"
      :src="imageSrc"
      alt="cropper image"
      :checkOrientation="false"
      :autoCrop="false"
      :aspectRatio="aspectRatio"
      :initialAspectRatio="aspectRatio"
      @zoom="zoom"
    >
    </vue-cropper>
    <b-row align-v="center" align-h="between" class="cropper-options">
      <b-col
        cols=""
        class="text-left flex-between px-0"
        v-if="state === 'CROP'"
      >
        <span class="cropper-options__icon" @click="zoomOut">
          <mdicon name="magnify-minus-outline" size="24" />
        </span>
        <input
          class="range"
          type="range"
          :min="minRange"
          :max="maxRange"
          :step="stepRange"
          v-model="range"
          @change="changeRange"
          :disabled="true"
        />
        <span class="cropper-options__icon" @click="zoomIn">
          <mdicon name="magnify-plus-outline" class="mdi-flip-h" size="24" />
        </span>
      </b-col>
      <b-col
        cols="auto"
        class="text-left flex-between"
        v-if="state === 'ROTATE'"
      >
        <div class="cropper-options__item" @click="rotate(-90)">
          <span class="cropper-options__text">{{ $lang.left }}</span>
          <span class="cropper-options__icon cropper-options__icon--flip-h">
            <mdicon name="refresh" class="mdi-flip-h" size="20" />
          </span>
        </div>
        <div class="cropper-options__item" @click="rotate(90)">
          <span class="cropper-options__text">{{ $lang.right }}</span>
          <span class="cropper-options__icon">
            <mdicon name="refresh" size="20" />
          </span>
        </div>
      </b-col>
      <b-col cols="auto">
        <span
          v-if="state === 'ROTATE'"
          class="cropper-options__icon"
          @click="changeState('CROP')"
        >
          <mdicon name="crop" size="24" />
        </span>
        <span
          v-if="state === 'CROP'"
          class="cropper-options__icon"
          @click="changeState('ROTATE')"
        >
          <mdicon name="reload" size="24" />
        </span>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import { pathOr } from "ramda";

export default {
  components: { VueCropper },
  props: {
    file: {
      type: [Object, File],
      default: null,
    },
    aspectRatio: {
      type: Number,
      default: 1 / 1,
    },
  },
  data() {
    return {
      state: "ROTATE",
      imageSrc: null,
      cropLoading: false,
      isCropLoading: false,
      show: false,
      range: 0,
      minRange: -5,
      maxRange: 5,
      stepRange: 1,
    };
  },
  watch: {
    file: {
      immediate: true,
      handler(value) {
        if (value) {
          this.imageSrc = URL.createObjectURL(value);
        }
      },
    },
    range: {
      immediate: true,
      handler(newValue, oldValue) {
        if (+newValue <= this.minRange) {
          return this.$notify.warning(
            "از این اندازه بیشتر امکان کوچک نمایی نمی باشد!"
          );
        }
        if (+newValue >= this.maxRange) {
          return this.$notify.warning(
            "از این اندازه بیشتر امکان بزرگ نمایی نمی باشد!"
          );
        }

        if (oldValue !== undefined) {
          if (+newValue < +oldValue) {
            this.zoom(-this.stepRange);
          } else {
            this.zoom(this.stepRange);
          }
        }
      },
    },
  },
  methods: {
    pathOr,
    changeState(state, action = true) {
      this.state = state;
      if (state === "ROTATE") {
        action && this.reset();
      }
      if (state === "CROP") {
        action && this.initCrop();
      }
    },
    changeRange() {
      this.zoom(+this.range);
    },
    zoom(index) {
      this.$refs.vueCropper.relativeZoom(index);
    },
    zoomIn() {
      if (+this.range >= this.maxRange) return;
      +this.range++;
    },
    zoomOut() {
      if (+this.range <= this.minRange) return;
      +this.range--;
    },
    rotate(direction) {
      this.$refs.vueCropper.rotate(direction);
    },
    reset() {
      this.range = 0;
      this.$refs.vueCropper.reset();
      this.$refs.vueCropper.clear();
      // this.$refs.vueCropper.clearCrop();
    },
    initCrop() {
      this.$refs.vueCropper.initCrop();
    },
    cropImage({ coordinates, canvas }) {
      this.coordinates = coordinates;
      this.image_dispay = canvas.toDataURL();
    },
    dataURLtoFile(dataUrl, fileName) {
      let arr = dataUrl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], fileName, { type: mime });
    },
    async submit() {
      try {
        /* await this.$refs.vueCropper.getCroppedCanvas().toBlob((blob) => {
          let image = new File([blob], this.file.name, {
            type: this.file.type,
          });
          let id = this.file.id ? this.file.id : null;
          let payload = {
            id: id,
            img: image,
            attachment_type_id:
              this.file.attachment_type && this.file.attachment_type.id,
          };
          this.$emit("save", payload);
        }); */
        const base64Image = await this.$refs.vueCropper
          .getCroppedCanvas()
          .toDataURL("image/jpeg", 0.9);
        const image = this.dataURLtoFile(base64Image, this.file.name);
        this.$emit("submit", image);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.show = false;
        this.changeState("ROTATE", false);
      }
    },
  },
  destroyed() {
    this.changeState("ROTATE", false);
  },
};
</script>
